import * as React from "react";
import {map as _map} from "lodash";
import IHabitNew from "../../../models/IHabitNew";

/**
 * Created by abhinav on 28/01/18.
 */

export interface PatientHabitViewProps {
    habits: IHabitNew[];
}

class PatientHabitView extends React.Component<PatientHabitViewProps> {

    constructor(props: PatientHabitViewProps) {
        super(props);
    }

    render() {
        let habits = this.props.habits;
        return (
            <div className="patient-habit-view">
                {
                    habits.length ?
                    _map(this.props.habits, function(habit: IHabitNew, index: number){
                        return (
                            <div className="habit-tag" key={index}>
                                <div className="habit-name">{habit.habitName}</div>
                                <div className="habit-comment">{habit.frequency}</div>
                            </div>
                        )
                    }) : <div className={"no-record-found-label"}>No habit data found</div>
                }
            </div>
        );
    }
}

export default PatientHabitView